import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WaveWinnersDropHeaderVoter from "./WaveWinnersDropHeaderVoter";
interface WaveWinnersDropHeaderVotersProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderVoters(t0) {
  const $ = _c(23);
  const {
    winner
  } = t0;
  const hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context?.rating !== 0;
  const userVote = winner.drop.context_profile_context?.rating ?? 0;
  const isNegativeVote = userVote < 0;
  let t1;
  if ($[0] !== isNegativeVote || $[1] !== winner.place) {
    const topThreeRankStyles = {
      1: "tw-text-[#E8D48A]",
      2: "tw-text-[#DDDDDD]",
      3: "tw-text-[#CD7F32]"
    };
    const getVoteStyle = (rank, isNegative) => {
      if (rank && rank <= 3) {
        return topThreeRankStyles[rank];
      }
      if (isNegative) {
        return "tw-bg-gradient-to-r tw-from-red tw-to-red tw-bg-clip-text tw-text-transparent";
      }
      return "tw-bg-gradient-to-r tw-from-emerald-400 tw-to-emerald-500 tw-bg-clip-text tw-text-transparent";
    };
    t1 = getVoteStyle(winner.place, isNegativeVote);
    $[0] = isNegativeVote;
    $[1] = winner.place;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rankStyle = t1;
  let t2;
  if ($[3] !== winner) {
    t2 = winner.drop.top_raters.map((voter, index) => <WaveWinnersDropHeaderVoter voter={voter} winner={winner} index={index} key={voter.profile.handle} />);
    $[3] = winner;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="tw-flex -tw-space-x-1.5 tw-items-center">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== winner.drop.raters_count) {
    t4 = formatNumberWithCommas(winner.drop.raters_count);
    $[7] = winner.drop.raters_count;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="tw-font-semibold">{t4}{" "}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = winner.drop.raters_count === 1 ? "voter" : "voters";
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <span className="tw-text-sm tw-text-iron-400">{t5}{t6}</span>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hasUserVoted || $[15] !== rankStyle || $[16] !== userVote || $[17] !== winner.drop.wave) {
    t8 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1"><span className="tw-text-sm"><span className="tw-text-iron-400">Your vote: </span><span className={`tw-font-semibold ${rankStyle}`}>{formatNumberWithCommas(userVote)}{" "}{winner.drop.wave.voting_credit_type}</span></span></div>;
    $[14] = hasUserVoted;
    $[15] = rankStyle;
    $[16] = userVote;
    $[17] = winner.drop.wave;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-3">{t3}{t7}{t8}</div>;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}